module.exports = __webpack_public_path__ + "img/sche.4faafda8.png";